<section fxLayout="row" fxLayout.xs="column" fxLayoutGap="20px">

  <bb-number number="3"></bb-number>
  <div fxLayout="column" fxFlex="100">

    <h2 class="request-txt">PERSONAL INFO</h2>

    <div fxLayout="row" fxLayoutGap="100px" fxLayout.xs="column" fxLayoutGap.xs="8px">
      <div fxLayout="column" fxFlex="35">
        <bb-full-name></bb-full-name>
        <bb-birthdate></bb-birthdate>
      </div>

      <div fxFlex="35">
        <bb-location></bb-location>
        <bb-contact-details></bb-contact-details>
      </div>

    </div>

    <div class="subtle">* Required fields</div>
  </div>

</section>
